/** @jsx React.createElement */
/** @jsxFrag React.Fragment */
import * as React from 'react';

import {InputReact} from 'common/components/input';
import {ValidationStatus} from 'common/components/input/types';

type Props = {
  placeholder?: string;
  validator?: (value: string) => boolean;
  parentHook?: (value: string) => void;
  defaultValue?: string;
  onBlur?: (value: string) => void;
};

export const TextInput = ({placeholder, validator, parentHook, defaultValue, onBlur}: Props) => {
  const [value, setValue] = React.useState(defaultValue ?? ``);
  const [validity, setValidity] = React.useState<ValidationStatus>(ValidationStatus.Default);

  React.useEffect(() => {
    if (validity === ValidationStatus.Valid) {
      parentHook && parentHook(value);
    }
  }, [validity]);

  return (
    <div
      onKeyDown={(event) => {
        if (event.key === `Enter`) {
          onBlur(value);
        }
      }}
    >
      <InputReact
        placeholder={placeholder}
        type='text'
        onInput={({target}) => setValue(target.value)}
        value={value}
        validationStatus={validity}
        onBlur={() => {
          if (value.length === 0) {
            setValidity(ValidationStatus.Default);
          } else if (!validator || validator(value)) {
            setValidity(ValidationStatus.Valid);
            onBlur(value);
          } else {
            setValidity(ValidationStatus.Invalid);
          }
        }}
        // @ts-ignore
        styleOverride={require(`./text-input.inline.styl`)}
      />
    </div>
  );
};
